<template>
	<div class="rt-detail">
		<div class="rt-head">
			<v-icon small class="mr-1">mdi-keyboard-return</v-icon>
			<span class="rt-head-title">Reso ordine {{ item.OrderID }}</span>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" class="mr-2" @click="$emit('edit')"><v-icon left x-small>mdi-pencil</v-icon>Modifica</v-btn>
			<v-btn v-if="item._order" x-small outlined color="primary" @click="$emit('open-order')"><v-icon left x-small>mdi-magnify</v-icon>Apri ordine</v-btn>
		</div>

		<div class="rt-body">
			<div class="rt-main">
				<div class="rt-section">Articoli resi</div>
				<div v-if="!articoli.length" class="rt-empty">Nessun articolo selezionato per il reso</div>
				<div v-else class="rt-lines">
					<div v-for="(el, i) in articoli" :key="el._id || i" class="rt-line">
						<div class="rt-thumb">
							<img v-if="miniatura(el)" :src="miniatura(el)" alt="" loading="lazy" />
							<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
						</div>
						<div class="rt-line-main">
							<div class="rt-line-title" :title="el.Title">{{ el.Title || 'Prodotto' }}</div>
							<div class="rt-line-sub">SKU {{ el.SKU || '—' }} · pagato {{ euro(el.TransactionPrice) }}</div>
						</div>
						<div class="rt-line-qty" title="Quantità resa / acquistata">
							<span class="font-weight-bold">{{ el.QuantityReturned || 0 }}</span><span class="rt-muted">/{{ el.QuantityPurchased || 0 }}</span>
						</div>
						<div class="rt-line-price">{{ euro(el.PriceReturned) }}</div>
					</div>
					<div class="rt-total">
						<span>Totale reso</span>
						<span>
							<strong>{{ euro(item.Total) }}</strong>
							<span v-if="item.TotalOrder" class="rt-muted"> su {{ euro(item.TotalOrder) }} dell'ordine</span>
						</span>
					</div>
				</div>
			</div>

			<div class="rt-side">
				<div class="rt-section">Condizioni</div>
				<div class="rt-checks">
					<div v-for="c in condizioni" :key="c.label" class="rt-check" :class="c.valore ? 'rt-check--ok' : 'rt-check--ko'">
						<v-icon small>{{ c.valore ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
						<span>{{ c.label }}</span>
					</div>
				</div>

				<template v-if="item.Message">
					<div class="rt-section mt-4">Messaggio del cliente</div>
					<div class="rt-message">
						<div class="rt-message-author">
							<v-icon x-small color="primary" class="mr-1">mdi-account</v-icon>{{ cliente }}
							<span v-if="item.Lang" class="rt-muted"> · {{ String(item.Lang).toUpperCase() }}</span>
						</div>
						<div class="rt-message-text">{{ item.Message }}</div>
					</div>
				</template>

				<template v-if="spedizione">
					<div class="rt-section mt-4">Spedizione ordine</div>
					<div class="rt-muted rt-small">{{ spedizione }}</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { immagineRiga } from '@/utils/immagineProdotto';

// dettaglio di un reso nella riga espansa (desktop) e nella card (mobile)
export default {
	name: 'ReturnDetail',
	props: {
		item: { type: Object, required: true },
	},
	computed: {
		// solo gli articoli scelti per il reso
		articoli() {
			return (this.item.Items || []).filter(el => el.selected);
		},
		condizioni() {
			return [
				{ label: 'Confezione originale', valore: !!this.item.original },
				{ label: 'Accessori presenti', valore: !!this.item.accessories },
				{ label: 'Rientro a magazzino', valore: !!this.item.stock },
			];
		},
		cliente() {
			const b = this.item.buyer || {};
			return [b.name, b.lastname].filter(Boolean).join(' ') || b.email || 'Cliente';
		},
		spedizione() {
			const s = this.item.ShippingService || {};
			if (!s.ShippingService) return '';
			return s.ShippingServiceCost != null ? `${s.ShippingService} · ${this.euro(s.ShippingServiceCost)}` : s.ShippingService;
		},
	},
	methods: {
		miniatura(el) {
			return immagineRiga(el, this.item.itemsImages);
		},
		euro(valore) {
			const n = Number(valore);
			return valore === null || valore === undefined || isNaN(n) ? '—' : `${n.toFixed(2).replace('.', ',')} €`;
		},
	},
};
</script>

<style scoped>
.rt-detail {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	width: 100%;
}
.rt-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.rt-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.rt-body {
	display: grid;
	grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
	gap: 16px;
	padding: 12px;
}
.rt-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.rt-empty,
.rt-muted {
	color: #5f6b7a;
}
.rt-small {
	font-size: 13px;
}
.rt-lines {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.rt-line {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 12px;
	font-size: 14px;
}
.rt-line + .rt-line {
	border-top: 1px solid #eef2f7;
}
.rt-line-main {
	flex: 1 1 auto;
	min-width: 0;
}
.rt-thumb {
	flex: 0 0 48px;
	width: 48px;
	height: 48px;
	border-radius: 6px;
	border: 1px solid #e1e7ef;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.rt-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.rt-line-title {
	font-weight: 500;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.rt-line-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.rt-line-qty {
	flex: 0 0 auto;
	white-space: nowrap;
}
.rt-line-price {
	flex: 0 0 86px;
	text-align: right;
	font-weight: 600;
	white-space: nowrap;
}
.rt-total {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	padding: 8px 12px;
	background: #f7f9fc;
	border-top: 1px solid #e1e7ef;
	font-size: 14px;
}
.rt-total > span:first-child {
	white-space: nowrap;
}
.rt-checks {
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.rt-check {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
}
.rt-check--ok .v-icon {
	color: #2e7d32 !important;
}
.rt-check--ko .v-icon {
	color: #c62828 !important;
}
.rt-check--ko span {
	color: #5f6b7a;
}
.rt-message {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 12px;
	border-top-left-radius: 3px;
	padding: 8px 12px;
}
.rt-message-author {
	font-size: 12px;
	font-weight: 600;
	color: #01579b;
	margin-bottom: 2px;
}
.rt-message-text {
	font-size: 14px;
	line-height: 1.5;
	white-space: pre-line;
	word-break: break-word;
}

@media (max-width: 768px) {
	.rt-detail {
		margin: 0 -4px;
	}
	.rt-body {
		grid-template-columns: 1fr;
		padding: 8px;
	}
	.rt-line {
		flex-wrap: wrap;
		gap: 4px 12px;
	}
	.rt-line-main {
		flex-basis: calc(100% - 60px);
	}
	.rt-line-title {
		white-space: normal;
	}
	.rt-line-qty {
		flex: 1 1 auto;
	}
}
</style>
